module.exports = __webpack_public_path__ + "91635f8d56f7048124feb375f7547f59.pdf";